import { maybe, Maybe } from '@passionware/monads';
import { workspaceIdFromScope } from 'v5/api/_common/query/workspace-scoping';
import type {
  EnterpriseTeamsQuery,
  EnterpriseWorkspace
} from 'v5/api/enterprise/enterprise.api';
import type { ResolvedAppScope } from '../appScope.types';

/**
 * `useTeams` query from browsing scope: workspace/team URLs → that workspace;
 * org URL or unresolved scope → absent (do not list teams).
 */
export function enterpriseTeamsQueryFromResolvedScope(
  scope: Maybe<ResolvedAppScope>
): Maybe<EnterpriseTeamsQuery> {
  return maybe.map(scope, s =>
    maybe.map(workspaceIdFromScope(s), workspaceId => ({
      organizationId: s.organizationId,
      workspaceId
    }))
  );
}

/**
 * Team list queries for `useTeams` — one workspace when scoped, all workspaces on org.
 */
export function enterpriseTeamsQueriesFromScope(
  scope: Maybe<ResolvedAppScope>,
  workspaces: EnterpriseWorkspace[] | undefined
): EnterpriseTeamsQuery[] {
  const single = enterpriseTeamsQueryFromResolvedScope(scope);
  if (maybe.isPresent(single)) {
    return [single];
  }

  const organizationId = scope?.organizationId;
  if (!organizationId || !workspaces?.length) {
    return [];
  }

  return workspaces.map(workspace => ({
    organizationId,
    workspaceId: workspace.id
  }));
}
